import { useSelector, useDispatch } from 'react-redux';
import { Text } from 'rsuite';
import React, { useEffect, useMemo } from 'react';
import {
  PresentationGrid,
  PresentationRow,
  PresentationCol,
} from '../../layout/PresentationLayout';
import { getPropertyContactsByApplicationNumberAsync } from '../../../store/slices/licenseView/licenseViewThunks';
import {
  selectPropertyContacts,
  selectPropertyContactsInProgress,
  selectPropertyContactsSuccess,
  selectPropertyContactsErrorMsg,
} from '../../../store/slices/licenseView/licenseViewSelectors';
import IconIndicator from '../../user-feedback/IconIndicator';
import Notice from '../../user-feedback/Notice';
import { listOfUniquePeopleWithAllRoles } from './helper';
import PropertyContact from './PropertyContact';
import { selectGlobalsTranslations } from '../../../store/slices/globals/globalsSelectors';
import { C_DEFAULT_TRANSLATIONS } from '../../../common/consts';

const PropertyContacts = ({ applicationNumber }) => {
  const dispatch = useDispatch();

  const propertyContacts = useSelector(selectPropertyContacts);
  const propertyContactsLoading = useSelector(selectPropertyContactsInProgress);
  const propertyContactsSuccess = useSelector(selectPropertyContactsSuccess);
  const propertyContactsErrorMesage = useSelector(
    selectPropertyContactsErrorMsg
  );
  const translations = useSelector(selectGlobalsTranslations);

  useEffect(() => {
    dispatch(getPropertyContactsByApplicationNumberAsync(applicationNumber));
  }, [dispatch]);

  const organizedContacts = useMemo(() => {
    if (propertyContactsLoading) {
      return [];
    } else {
      return listOfUniquePeopleWithAllRoles(
        propertyContacts,
        translations,
        C_DEFAULT_TRANSLATIONS
      );
    }
  }, [propertyContacts, propertyContactsLoading]);

  return (
    <PresentationGrid fluid>
      <PresentationRow className="mb-24">
        <PresentationCol xs={24}>
          <Text
            as="h4"
            className="text-bold header-text-h4"
          >
            Property Contacts
          </Text>
        </PresentationCol>
      </PresentationRow>

      {propertyContactsLoading && (
        <PresentationRow>
          <PresentationCol xs={24}>
            <IconIndicator />
          </PresentationCol>
        </PresentationRow>
      )}

      {!propertyContactsLoading &&
        propertyContactsSuccess &&
        organizedContacts.map(([data, roles], i) => (
          <PresentationRow key={`organized_contacts_${i}`}>
            <PropertyContact
              key={i}
              data={data}
              roles={roles}
            />
          </PresentationRow>
        ))}

      {!propertyContactsSuccess &&
        !propertyContactsLoading &&
        propertyContactsErrorMesage && (
          <PresentationRow>
            <Notice message={propertyContactsErrorMesage} />
          </PresentationRow>
        )}
    </PresentationGrid>
  );
};

export default PropertyContacts;
